import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React from 'react'

function TableHeader({ columns, order, orderBy, onRequestSort }) {

    const createSortHandler = (property, order) => (event) => {
        onRequestSort(property, order);
    }

    const renderCell = (col, index) => {
        if (!col.sortable) {
            return (<React.Fragment key={index}>
                {col.label}
            </React.Fragment>)
        }
        return (<TableSortLabel
            key={index}
            active={orderBy === col.key}
            direction={orderBy === col.key ? order : 'asc'}
            onClick={createSortHandler(col.key, order)}
        >
            {col.label}
        </TableSortLabel>)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map((col, index) => (
                    <TableCell key={col.key + "-" + index} sx={col.style} align={col?.align}>
                        {renderCell(col, index)}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

export default TableHeader